import { RadioGroup } from "@headlessui/react";
import Image from "next/image";
import { useTranslations } from "next-intl";

import IconDone from "@/icons/icon-done";
import CrossCountry from "~/types/cross-country";
import imageUtils from "~/utils/image-utils";
import productUtils from "~/utils/product-utils";

import Icon from "../common/icon";
import styles from "./cart-pick-product-option.module.scss";

type Props = {
  product: CrossCountry.ChildrenProduct;
  currentSelection?: string | undefined;
  onSelect?: (productId: string) => void;
};

export default function CartPickProductOption(props: Props) {
  const t = useTranslations();
  const primary = props.product.product_media?.primary_image;
  const goccia = productUtils.getProductDroplet(props.product.product_media?.media);

  // value={props.option.CurrentSelection}
  // onChange={(productId) => }

  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <Image
          src={primary?.url || imageUtils.transparentPixel}
          alt={props.product.display_value}
          width={80}
          height={80}
          loader={imageUtils.evaImageLoader}
        />
      </div>
      <div className={styles.infoContainer}>
        <p className={styles.productName}>{props.product.display_value}</p>
        <div className={styles.colorContainer}>
          {props.product.color && props.product.color !== "N/A" && goccia?.url ? (
            <>
              <Image
                src={goccia?.url || imageUtils.transparentPixel}
                alt={props.product.color || ""}
                width={12}
                height={12}
                className={styles.colorImage}
                loader={imageUtils.evaImageLoader}
              />
              <p className={styles.colorName}>{props.product.color}</p>
            </>
          ) : null}
        </div>
        {props.onSelect &&
          (props.currentSelection === props.product.product_id ? (
            <div className={styles.checked}>
              <p>{t("generic.cart.selected_gift")}</p>
              <Icon icon={IconDone} width={16} height={16} />
            </div>
          ) : (
            <button className={styles.unchecked} onClick={() => props.onSelect?.(props.product.product_id)}>
              <p>{t("generic.cart.unselected_gift")}</p>
            </button>
          ))}
      </div>
    </div>
  );
}
